import type { FC } from 'react';
import { cx } from '@linaria/atomic';
import { getPanelFeaturePromotionBannerAccentCssVars } from './accent';
import {
  PanelFeaturePromotionBannerActions,
  PanelFeaturePromotionBannerDismissMenu,
} from './atoms/panel-feature-promotion-banner-actions';
import {
  PanelFeaturePromotionBannerFeatureChip,
  PanelFeaturePromotionBannerFeatureChips,
} from './atoms/panel-feature-promotion-banner-chips';
import {
  PanelFeaturePromotionBannerBody,
  PanelFeaturePromotionBannerDescription,
  PanelFeaturePromotionBannerTitle,
} from './atoms/panel-feature-promotion-banner-content';
import { PanelFeaturePromotionBannerHeader } from './atoms/panel-feature-promotion-banner-header';
import {
  PanelFeaturePromotionBannerBullet,
  PanelFeaturePromotionBannerHighlight,
  PanelFeaturePromotionBannerHighlights,
} from './atoms/panel-feature-promotion-banner-highlights';
import { PanelFeaturePromotionBannerMedia } from './atoms/panel-feature-promotion-banner-media';
import { styles } from './panel-feature-promotion-banner.styles';
import type { PanelFeaturePromotionBannerProps } from './panel-feature-promotion-banner.types';

export interface PanelFeaturePromotionBannerComponent extends FC<PanelFeaturePromotionBannerProps> {
  Header: typeof PanelFeaturePromotionBannerHeader;
  Body: typeof PanelFeaturePromotionBannerBody;
  Title: typeof PanelFeaturePromotionBannerTitle;
  Description: typeof PanelFeaturePromotionBannerDescription;
  FeatureChips: typeof PanelFeaturePromotionBannerFeatureChips;
  FeatureChip: typeof PanelFeaturePromotionBannerFeatureChip;
  Media: typeof PanelFeaturePromotionBannerMedia;
  Highlights: typeof PanelFeaturePromotionBannerHighlights;
  Highlight: typeof PanelFeaturePromotionBannerHighlight;
  Bullet: typeof PanelFeaturePromotionBannerBullet;
  Actions: typeof PanelFeaturePromotionBannerActions;
  DismissMenu: typeof PanelFeaturePromotionBannerDismissMenu;
}

export const PanelFeaturePromotionBanner: PanelFeaturePromotionBannerComponent = ({
  accent = 'seaweed',
  className,
  innerRef,
  testId = 'panel-feature-promotion-banner',
  children,
}) => {
  const accentStyles = getPanelFeaturePromotionBannerAccentCssVars(accent);

  return (
    <div ref={innerRef} className={cx(styles.container, className)} style={accentStyles} data-testid={testId}>
      {children}
    </div>
  );
};

PanelFeaturePromotionBanner.Header = PanelFeaturePromotionBannerHeader;
PanelFeaturePromotionBanner.Body = PanelFeaturePromotionBannerBody;
PanelFeaturePromotionBanner.Title = PanelFeaturePromotionBannerTitle;
PanelFeaturePromotionBanner.Description = PanelFeaturePromotionBannerDescription;
PanelFeaturePromotionBanner.FeatureChips = PanelFeaturePromotionBannerFeatureChips;
PanelFeaturePromotionBanner.FeatureChip = PanelFeaturePromotionBannerFeatureChip;
PanelFeaturePromotionBanner.Media = PanelFeaturePromotionBannerMedia;
PanelFeaturePromotionBanner.Highlights = PanelFeaturePromotionBannerHighlights;
PanelFeaturePromotionBanner.Highlight = PanelFeaturePromotionBannerHighlight;
PanelFeaturePromotionBanner.Bullet = PanelFeaturePromotionBannerBullet;
PanelFeaturePromotionBanner.Actions = PanelFeaturePromotionBannerActions;
PanelFeaturePromotionBanner.DismissMenu = PanelFeaturePromotionBannerDismissMenu;
